/** @format */

import React, { useState, useRef } from "react";
// import { fileUpload } from "../../utils/utils";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
// import { InputText } from 'primereact/inputtext';
import service from "./service/service";
import useSaveAdLinks from "./hooks/useSaveAdLinks";
import { Messages } from "primereact/messages";
import { isAdvertisementLinkEmpty } from "./utils/utils";

function AdvertisementBanner(props) {
  // const [url, setURL] = useState("");
  const [temp, setTemp] = useState("");
  const [editContent, setEditContent] = useState(false);
  const [isSectionInValid, setIsSectionInValid] = useState(false);
  const [adList, setAdList] = useState([]);
  let section = props.section;
  let loading = props.loading;
  const msgRef = useRef();
  const mutation = useSaveAdLinks();
  // function updateRedirectLink(e) {
  //   setURL(e.target.value)
  //   section.redirectLink = e.target.value;
  // }
  function handleEdit() {
    setEditContent(true);
  }
  function handleSave() {
    // setURL(temp);
    props.updateImagePath(section, temp, "");
    setEditContent(false);
  }
  function handleCancel() {
    setEditContent(false);
  }
  // async function handleImageUpload(e, section) {
  //   let imagePath = await fileUpload(e.target.files, section);
  //   // setURL(imagePath);
  //   props.updateImagePath(section, imagePath);
  // }
  React.useEffect(() => {
    service.getAdvertisements().then((response) => {
      setAdList(response.data);
    });
  }, []);

  function handleSectionSave() {
    if (isAdvertisementLinkEmpty(section)) {
      setIsSectionInValid(true);
    } else {
      mutation.mutate(
        {
          ...section,
          reportDate: props.reportDate,
          regionId: props.regionId,
          productLineId: props.productLineId,
        },
        {
          onSuccess: (data) => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: false,
                  severity: "success",
                  summary: "Success",
                  detail: "Advertisement saved successfully",
                  closable: false,
                  life: 2000,
                },
              ]);
            }
            props.updateSectionId("syndicationAdvertisementBanner", data.data);
            mutation.reset();
          },
          onError: () => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: true,
                  severity: "error",
                  summary: "Error",
                  detail: "Error saving Advertisement",
                  closable: true,
                },
              ]);
            }
            mutation.reset();
          },
        }
      );
    }
  }
  return (
    <div className='relative syndication__section__wrapper'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td>
              {section.redirectLink === "" ? (
                <div>Please Update the Advertisement Section and add the redirectLink</div>
              ) : (
                <></>
              )}
              {props.publish === false && props.diff_date >= 0 ? (
                <span className='add_link_verbiage'>
                  Advertisement Link:
                  {/* <textarea
                    value={url}
                    style={{ display: "block", whiteSpace: "pre-wrap" }}
                    rows="1"
                    cols="100"
                    className="p-inputtext"
                    onChange={(e) => {
                      updateRedirectLink(e);
                    }}
                  /> */}
                  <tr className='editContent'>
                    <td>
                      <span
                        style={{ cursor: "pointer", fontSize: "16px", color: "grey" }}
                        onClick={() => {
                          handleEdit();
                        }}
                      >
                        Choose Advertisement
                      </span>
                      {/* <span
                        style={{ cursor: "pointer",fontSize: "16px", color: "grey", marginLeft: "10px" }}
                        onClick={() => {
                          handleSectionSave();
                        }}
                      >
                        Save Section Image
                      </span> */}
                    </td>
                  </tr>
                </span>
              ) : (
                <></>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          marginBottom: "10px",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td valign='top' align='center'>
              {section.imagePath !== "" ? (
                <div>
                  <a href={section.redirectUrl} target='_blank' rel='noopener noreferrer'>
                    <img
                      width={800}
                      height={100}
                      style={{
                        width: "100%",
                        textAlign: "justify",
                        height: "100px",
                      }}
                      alt='Advertisement Banner'
                      src={decodeURIComponent(encodeURIComponent(section.imagePath))}
                    />
                  </a>
                  {props.publish === false && props.diff_date >= 0 ? (
                    <button
                      className='RemoveImage diag-save-button floatRight'
                      style={{
                        borderRadius: "35px",
                        marginRight: 0,
                        textAlign: "center",
                        padding: "10px",
                        color: "#FFFFFF",
                        boxSizing: "border-box",
                        backgroundColor: "#199B8B",
                      }}
                      onClick={() => {
                        props.updateImagePath(section, "", "");
                        // setURL("");
                      }}
                    >
                      Remove image
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div>
                  {/* Select an Ad of Max size 800x100
                  <div>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => {
                        handleImageUpload(e, section);
                      }}
                    />
                  </div> */}
                </div>
              )}
              {props.publish === false && props.diff_date >= 0 ? (
                <Button
                  pt={{ label: { className: "mx-0" } }}
                  className='floatLeft p-button p-button-sm diag-save-button savesectionbtn ml-0'
                  label='Save Section Image'
                  onClick={() => handleSectionSave()}
                />
              ) : null}
            </td>
          </tr>
        </tbody>
      </table>
      <Dialog
        baseZIndex={10001}
        className='diag1'
        visible={editContent}
        style={{ width: "1000px" }}
        onHide={() => handleCancel()}
        onShow={() => setTemp("")}
        focusOnShow={false}
      >
        <div className='diag-box'>
          <div className='grid'>
            <div className='col-12 p-0 diag-syndication'>Choose Advertisement</div>
            {adList.map((ad, ind) => {
              let src_alt = decodeURIComponent(encodeURIComponent(ad.imageURL));
              return (
                <div className='col-12' key={ind}>
                  <img
                    src={src_alt}
                    alt={src_alt}
                    onClick={() => {
                      setTemp(ad);
                    }}
                  ></img>
                </div>
              );
            })}
            <div className='col-12 pl-0'>
              <div className='col-12 p-0 diag-syndication'>Selected Advertisement</div>
              {/* <InputText className="widthFull" required rows={1}
                value={temp}
                onChange = {(event) => setTemp(event.target.value)}
              /> */}
              {temp !== "" ? (
                <div className='col-12'>
                  <img src={decodeURIComponent(encodeURIComponent(temp.imageURL))} alt={temp.imageURL}></img>
                </div>
              ) : (
                <p>Click on an Ad to select it</p>
              )}
            </div>
            <div className='col-12'>
              <Button
                label='Cancel'
                className='p-button floatRight p-button-sm diag-discard-button'
                onClick={() => handleCancel()}
              />
              <Button
                label='Save'
                onClick={() => handleSave(section)}
                className='p-button floatRight p-button-sm diag-save-button'
              />
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header='Advertisement Validation'
        className='section__validation__dialog'
        baseZIndex={10001}
        visible={isSectionInValid}
        modal
        style={{ width: "350px" }}
        footer={
          <Button
            label='Okay'
            icon='pi pi-check'
            onClick={() => setIsSectionInValid(false)}
            className='p-button-text'
          />
        }
        onHide={() => setIsSectionInValid(false)}
      >
        <div className='flex flex-column' style={{ color: "#FFF" }}>
          <div className='flex align-items-center'>
            <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
            <span>Please fill the section content</span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default AdvertisementBanner;
